//https://tech.route06.co.jp/entry/2024/04/08/122004
import { fetchAuthSession, getCurrentUser, signOut } from "aws-amplify/auth";

let currentSessionRequest = null;

const getCurrentSession = async () => {
  if (currentSessionRequest) {
    return currentSessionRequest;
  }

  currentSessionRequest = (async () => {
  try {
    const { tokens: session } = await fetchAuthSession();
    return session || null;
  } catch (err) {
    return null;
  } finally {
    currentSessionRequest = null;
  }
  })();

  return currentSessionRequest;
};

const getIdToken = async () => {
  const session = await getCurrentSession();
  return session?.idToken?.toString() || null;
};

const getAuthenticatedUser = async () => {
  const session = await getCurrentSession();
  if (!session) {
    return {
      userId: null,
      session: null,
      signInDetails: null,
      authenticationFlowType: null,
    };
  }

  const { userId, signInDetails } = await getCurrentUser();
  return {
    userId,
    session,
    signInDetails,
    authenticationFlowType: signInDetails.authFlowType,
  };
};

const logout = async () => {
  try {
    await signOut({ global: true });
  } catch (err) {
    console.error("ログアウト失敗:", err);
  }
};

export { getAuthenticatedUser, getIdToken, logout };
